import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('/api/send-contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Erreur lors de l\'envoi');
      }

      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Il y a eu une erreur dans l\'envoi de votre message.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>The Recap - Nous contacter</title>
        <meta name="description" content="Parlons de vos enjeux retail & e-commerce : contactez The Recap pour une demande d'info, de partenariat ou de décryptage d'événement." />
        <meta property="og:title" content="The Recap - Nous-contacter" />
        <meta property="og:description" content="Parlons de vos enjeux retail & e-commerce : contactez The Recap pour une demande d'info, de partenariat ou de décryptage d'événement." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <section className="contact-section">
        <div className="contact-container fade-in">
          <h1 className="contact-title">Une question, un projet, une envie d'échanger ?</h1>
          <p className="contact-subtitle">Laissez-nous un message, nous vous recontactons rapidement.</p>

          {submitted ? (
            <div className="contact-success">
              Merci ! Votre message a bien été envoyé !
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name" className="form-label">Nom</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-input"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  name="message"
                  className="form-textarea"
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              {error && (
                <div className="contact-error">
                  {error}
                </div>
              )}
              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? 'Envoi en cours...' : 'Envoyer'}
              </button>
            </form>
          )}
        </div>
      </section>
    </>
  );
};

export default ContactPage;
